export function transformCASAccount(CAS) {
  return {
    redirectUrl: CAS.url
  };
}
